import {CardView} from "../Helper/cardView";
import {Text, VStack} from "@chakra-ui/react";

export function HomeHeader() {
    return (
        <CardView
            backgroundColor="red"
            backgroundHeight={["60vh", "70vh", "80vh"]}
            stackAlign="center"
        >
            <VStack>
                <Text
                    fontSize={["4xl", "5xl", "6xl"]}
                    fontWeight="black"
                    align="center"
                >
                    Mafia: The Game
                </Text>
                <Text
                    fontSize="2xl"
                    fontWeight="bold"
                    align="center"
                >
                    The classic social mystery
                </Text>
            </VStack>
        </CardView>
    );
}